import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { InvoiceService } from "./../../../_services/invoice.service";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Component({
    selector: "app-submit-nonpo-invoice",
    templateUrl: "./submit-nonpo-invoice.component.html",
    styleUrls: ["./submit-nonpo-invoice.component.scss"],
})
export class SubmitNonpoInvoiceComponent implements OnInit {
    selectedCompany: any;
    invoiceTypes = [
        { label: "IRN e-invoice", type: "e-invoice" },
        { label: "Digitally Signed e-invoice", type: "ds-invoice" },
    ];
    file: any;
    impersonate;

    docs = [
        {
            docType: "NO1X",
            description: "NO1X - Non-PO",
        },
        {
            docType: "NO1G",
            description: "NO1G-Non-PO (Gases Only)",
        },
    ];

    loading = false;
    fileTypeError = false;
    qrCodeError = false;
    signatureError = false;
    validateSignature = false;
    validateEinvoice = false;
    validateEinvoiceResubmit = false;
    fileSizeError = false;
    responseData: any;
    displayName: any;
    message: any;
    poItems = [];
    files: any = [];
    poNo: any;
    fileUrl: any;
    safeUrl: any;
    pdfSrc: any;
    fileName: string = "";
    errorMessage: string = "";
    dsLoaderMsg = "";
    eLoaderMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    eLoaderMsgResubmit = "";
    timeoutID;
    formSubmitted = false;
    unathourizedEmail = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    emailRes: any;

    nonPoData = new FormGroup({
        invoiceType: new FormControl(null, [Validators.required]),
        file: new FormControl(null),
        fileSource: new FormControl("", [Validators.required]),
        email: new FormControl("", [
            Validators.required,
            Validators.email,
            Validators.pattern(
                "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
        ]),
        companyCode: new FormControl("", [Validators.required]),
        purchaseOrg: new FormControl("", [Validators.required]),
        docType: new FormControl("", [Validators.required]),
    });

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService,
        private authService: AuthService
    ) {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });
    }

    selectInvoice(event: any) {
        //this.loading = true;
        //this.validateSignature = true;
        const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
        this.qrCodeError = false;

        this.invoiceService.setFileElement(event[0]);
        localStorage.setItem("invoiceFile", event[0]);

        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.fileTypeError = true;
            } else if (fileUploaded.size > MAX_FILE_SIZE) {
                this.fileSizeError = true;
            } else {
                this.nonPoData.patchValue({
                    fileSource: fileUploaded,
                });
                this.fileTypeError = false;
                this.fileSizeError = false;
            }
        }

        this.fileName = event[0].name;

        // for (let file of event.target.files) {
        //     this.invoiceFile.length = 0;
        //     this.invoiceFile.push({
        //         name: file.name,
        //     });
        // }
    }

    extrationMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsg = msg;
        }, time);
    }

    extrationResubmitMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsgResubmit = msg;
        }, time);
    }

    onInvoiceSubmit() {
        //console.log(this.nonPoData.value);
        this.loading = true;
        this.qrCodeError = false;

        if (this.nonPoData.value.invoiceType === "e-invoice") {
            this.validateEinvoice = true;
            this.validateSignature = false;

            const validateEmailData = {
                action: "list",
                email: this.nonPoData.value.email,
                sellerCode: localStorage.getItem("vendorCode"),
                session: { sessionId: localStorage.getItem("userSession") },
            };

            this.authService
                .fetchExternalAnalytics(validateEmailData)
                .subscribe(
                    (res) => {
                        this.emailRes = res;
                        if (
                            this.emailRes.status === "successful" ||
                            this.emailRes.analytics.length !== 0
                        ) {
                            if (
                                this.emailRes.analytics.username !==
                                    "Not available" &&
                                this.emailRes.analytics.user_id !==
                                    "Not available"
                            ) {
                                this.invoiceService.setUsername(
                                    this.emailRes.analytics.username
                                );
                                this.invoiceService.setUserId(
                                    this.emailRes.analytics.user_id
                                );
                                this.invoiceService.setInvoiceType(
                                    "non_po_based"
                                );
                                this.invoiceService.setInvType("e-invoice");
                                const userData = {
                                    req: {
                                        emailAddress:
                                            this.nonPoData.value.email,
                                        companyCode:
                                            this.nonPoData.value.companyCode,
                                        purchaseOrg:
                                            this.nonPoData.value.purchaseOrg,
                                        docType: this.nonPoData.value.docType,
                                        poNumber: "",
                                        username: "",
                                        userId: "",
                                        items: [
                                            {
                                                poNumber: "",
                                                itemNo: "",
                                                grn: "",
                                            },
                                        ],
                                    },
                                    file: this.nonPoData.value.fileSource,
                                };
                                const formData: any = new FormData();
                                formData.append(
                                    "sellerCode",
                                    localStorage.getItem("vendorCode")
                                );
                                formData.append(
                                    "sessionId",
                                    localStorage.getItem("userSession")
                                );
                                formData.append(
                                    "invType",
                                    this.nonPoData.value.invoiceType
                                );
                                formData.append("invoiceType", "non_po_based");
                                formData.append(
                                    "req",
                                    JSON.stringify(userData.req)
                                );
                                formData.append(
                                    "file",
                                    this.nonPoData.value.fileSource
                                );
                                formData.append("extractionVersion", "1");

                                this.eLoaderMsg = "Verifying QR Code";
                                this.extrationMessages(
                                    "Authenticating QR Code",
                                    5000
                                );
                                this.extrationMessages(
                                    "Extracting Data",
                                    10000
                                );
                                this.extrationMessages(
                                    "Validating Data",
                                    15000
                                );

                                this.invoiceService
                                    .extractInvoice(formData)
                                    .subscribe(
                                        (res) => {
                                            this.loading = false;
                                            this.validateEinvoice = false;
                                            this.validateSignature = false;
                                            this.qrCodeError = false;
                                            this.responseData = res;
                                            //console.log(res);
                                            if (
                                                this.responseData.length !==
                                                    0 &&
                                                this.responseData.status ===
                                                    "error"
                                            ) {
                                                console.log("error");

                                                if (
                                                    this.responseData.msg.includes(
                                                        "unreadable"
                                                    )
                                                ) {
                                                    this.loading = true;
                                                    this.validateEinvoiceResubmit =
                                                        true;

                                                    this.eLoaderMsgResubmit =
                                                        "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

                                                    formData.set(
                                                        "extractionVersion",
                                                        "2"
                                                    );
                                                    //this.eLoaderMsg = "Authenticating QR Code";

                                                    this.extrationResubmitMessages(
                                                        "Verifying QR Code",
                                                        5000
                                                    );
                                                    this.extrationResubmitMessages(
                                                        "Authenticating QR Code",
                                                        10000
                                                    );
                                                    this.extrationResubmitMessages(
                                                        "Extracting Data",
                                                        15000
                                                    );
                                                    this.extrationResubmitMessages(
                                                        "Validating Data",
                                                        20000
                                                    );

                                                    setTimeout(() => {
                                                        this.invoiceService
                                                            .reExtractInvoice(
                                                                formData
                                                            )
                                                            .subscribe(
                                                                (res) => {
                                                                    this.responseData =
                                                                        res;

                                                                    if (
                                                                        this
                                                                            .responseData
                                                                            .length !==
                                                                            0 &&
                                                                        this
                                                                            .responseData
                                                                            .status ===
                                                                            "error"
                                                                    ) {
                                                                        this.validateEinvoiceResubmit =
                                                                            false;
                                                                        this.qrCodeError =
                                                                            true;
                                                                        this.message =
                                                                            this.responseData.msg;
                                                                    } else {
                                                                        this.qrCodeError =
                                                                            false;
                                                                        this.invoiceService.setProcessedInvoice(
                                                                            this
                                                                                .responseData
                                                                        );
                                                                        localStorage.setItem(
                                                                            "invoiceDetails",
                                                                            JSON.stringify(
                                                                                this
                                                                                    .responseData
                                                                            )
                                                                        );
                                                                        this.router.navigateByUrl(
                                                                            "/invoice-preview-nonpo"
                                                                        );
                                                                    }
                                                                },
                                                                (error) => {
                                                                    this.validateEinvoiceResubmit = false;
                                                                    this.qrCodeError = true;
                                                                    this.message =
                                                                        error?.msg ||
                                                                        error?.message ||
                                                                        "Unable to process the invoice. Please try again.";
                                                                    console.error("reExtractInvoice error:", error);
                                                                }
                                                            );
                                                    }, 22000);
                                                }
                                            } else {
                                                console.log("Success here");
                                                this.qrCodeError = false;
                                                this.invoiceService.setProcessedInvoice(
                                                    this.responseData
                                                );
                                                localStorage.setItem(
                                                    "invoiceDetails",
                                                    JSON.stringify(
                                                        this.responseData
                                                    )
                                                );
                                                this.router.navigateByUrl(
                                                    "/invoice-preview-nonpo"
                                                );
                                            }
                                        },
                                        (error) => {
                                            this.errorMessage = "We couldn't extract the invoice details due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
                                            console.log(error);
                                        }
                                    );
                            } else {
                                this.unathourizedEmail = true;
                                this.loading = false;
                            }
                        } else {
                            console.log(this.emailRes);
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.validateSignature = false;
                        this.signatureError = true;
                        this.message =
                            "We couldn't verify the signature due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
                            console.log(error);
                    }
                );
        } else {
            this.validateSignature = true;
            this.validateEinvoice = false;

            const validateEmailData = {
                action: "list",
                email: this.nonPoData.value.email,
                sellerCode: localStorage.getItem("vendorCode"),
                session: { sessionId: localStorage.getItem("userSession") },
            };

            this.authService
                .fetchExternalAnalytics(validateEmailData)
                .subscribe((res) => {
                    this.emailRes = res;
                    if (
                        this.emailRes.status === "successful" ||
                        this.emailRes.analytics.length !== 0
                    ) {
                        if (
                            this.emailRes.analytics.username !==
                                "Not available" &&
                            this.emailRes.analytics.user_id !== "Not available"
                        ) {
                            this.invoiceService.setInvoiceType("non_po_based");
                            this.invoiceService.setInvType("ds-invoice");
                            this.invoiceService.setUsername(
                                this.emailRes.analytics.username
                            );
                            this.invoiceService.setUserId(
                                this.emailRes.analytics.user_id
                            );
                            const fields = {
                                emailAddress: this.nonPoData.value.email,
                                companyCode: this.nonPoData.value.companyCode,
                                purchaseOrg: this.nonPoData.value.purchaseOrg,
                                docType: this.nonPoData.value.docType,
                                poNumber: "",
                                username: "",
                                userId: "",
                                items: [{ poNumber: "", itemNo: "", grn: "" }],
                            };

                            this.invoiceService.setNonPOFields(fields);
                            const formData: any = new FormData();
                            formData.append(
                                "sellerCode",
                                localStorage.getItem("vendorCode")
                            );
                            formData.append(
                                "sessionId",
                                localStorage.getItem("userSession")
                            );
                            formData.append(
                                "invoiceFile",
                                this.nonPoData.value.fileSource
                            );
                            formData.append(
                                "invType",
                                this.nonPoData.value.invoiceType
                            );
                            formData.append("invoiceType", "non_po_based");
                            this.dsLoaderMsg = "Verifying Signature";

                            setTimeout(() => {
                                this.dsLoaderMsg = "Authenticating Signature";
                            }, 2000);
                            setTimeout(() => {
                                this.dsLoaderMsg = "Extracting Data";
                            }, 4000);
                            setTimeout(() => {
                                this.dsLoaderMsg = "Validating Data";
                            }, 6000);

                            this.invoiceService
                                .verifyDigitalSignature(formData)
                                .subscribe(
                                    (res) => {
                                        this.loading = false;
                                        this.validateEinvoice = false;
                                        this.validateSignature = false;
                                        this.responseData = res;
                                        //console.log(res);
                                        if (
                                            this.responseData.length !== 0 &&
                                            this.responseData.status === "error"
                                        ) {
                                            this.loading = true;
                                            this.signatureError = true;
                                            this.message =
                                                this.responseData.msg;
                                        } else {
                                            this.qrCodeError = false;
                                            this.poNo =
                                                this.route.snapshot.params[
                                                    "poNo"
                                                ];
                                            this.invoiceService.setFileUrl(
                                                this.responseData.file_link
                                            );
                                            this.invoiceService.setDataDigitalInvoice(
                                                this.responseData.data
                                            );
                                            this.router.navigate([
                                                "/invoice-preview-digital-invoice-nonpo",
                                            ]);

                                            //localStorage.setItem('invoice', JSON.stringify(this.responseData));
                                        }
                                    },
                                    (error) => {
                                        this.loading = false;
                                        this.validateSignature = false;
                                        this.signatureError = true;
                                        this.message =
                                            error?.msg ||
                                            error?.message ||
                                            "Unable to verify signature. Please try again.";
                                    }
                                );
                        } else {
                            this.unathourizedEmail = true;
                            this.loading = false;
                        }
                    } else {
                        console.log(this.emailRes);
                    }
                });
        }
    }

    fetchPurchaseOrg() {
        const configReq = {
            configType: "purchaseOrganizations",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.log(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                }
            },
            (error) => {
                console.log(error);
                this.errorMessage = "We couldn't load the configuration due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            configType: "companyCodes",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.log(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                }
            },
            (error) => {
                console.log(error);
                this.errorMessage = "We couldn't load the configuration due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();
    }

    closeFileErrorDialog() {
        this.loading = false;
        this.fileTypeError = false;
        this.qrCodeError = false;
    }

    closeSignatureErrorDialog() {
        this.loading = false;
        this.signatureError = false;
        this.qrCodeError = false;
    }

    resubmitInvoice() {
        this.router.navigateByUrl("/submit-nonpo-invoice");
    }
}
